import React, { useEffect, useState } from 'react';
import { FailureLarge, SuccessLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getResponseText, putEmailIntoMessage } from './helpers';
import { ModalIconSvgPaddingStyled, ModalIconWrapperStyled } from './styled';
export function ResponseModalWindows({ labels, isRightToLeft, isSuccessStatus, onHideModal, emailText, notifyMeType, }) {
    const [successText, setSuccessText] = useState('');
    const { notifyMeGotItButton, commonErrorLabel, commonSomethingWentWrong } = labels;
    const { successLabelText, title } = getResponseText(notifyMeType, labels);
    useEffect(() => {
        const textResult = isSuccessStatus
            ? putEmailIntoMessage(successLabelText, emailText)
            : commonSomethingWentWrong;
        setSuccessText(textResult);
    }, [commonSomethingWentWrong, emailText, isSuccessStatus, successLabelText]);
    const modalFooter = (React.createElement(ModalWindowFooter, { onHide: onHideModal, submitButtonLabel: notifyMeGotItButton, isSubmitButton: true, isPreventedSubmit: true }));
    return (React.createElement(StaticModalWindow, { onHide: onHideModal, staticModalSize: MD_MODAL, title: isSuccessStatus ? title : commonErrorLabel, isRightToLeft: isRightToLeft, minHeight: !isSuccessStatus ? '192px' : undefined, footerComponent: modalFooter },
        React.createElement(ModalIconWrapperStyled, null,
            React.createElement(ModalIconSvgPaddingStyled, { isResponseSuccess: isSuccessStatus },
                React.createElement(SVGIcon, { type: isSuccessStatus ? SuccessLarge : FailureLarge, size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300, dangerouslySetInnerHTML: {
                __html: successText,
            } })));
}
